import Grid from '@material-ui/core/Grid';
import RoomIcon from '@material-ui/icons/Room';
import { getInfosIndividual } from '@webapps/business';
import { useQuery } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import AvatarStudent from 'components/Avatar/AvatarStudent';
import PropTypes from 'prop-types';

const ProfilName = ({ userId, absButton = false }) => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const { data: profilInfo = [] } = useQuery(getInfosIndividual, {
    key: ['profilInfo', userId],
    variables: { id: userId },
    enabled: typeof userId !== 'undefined',
  });

  return (
    <div className={classes.container}>
      <Grid className={classes.containerInfo} container>

        <div
          className={css({
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          })}
        >
          <div>
            <AvatarStudent applicant={profilInfo} height={90} width={90} />
          </div>
          <div className={css({ marginLeft: spacing(2) })}>
            <div className={cx(global.title, classes.name)}>
              {profilInfo?.firstname} {profilInfo?.lastname}
              {/* {info?.verified && (
              <VerifiedUserIcon
                className={css({ marginLeft: spacing(1) })}
                color="primary"
              />
            )} */}
            </div>
            <div className={cx(global.infoText, classes.address)}>
              {profilInfo?.address?.city && (
                <>
                  <RoomIcon className={global.infoIcon} />
                  <div>
                    {profilInfo?.address?.city} {profilInfo?.address?.cityCode}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </Grid>
      {/* <Grid className={classes.ButtonContainer} container item xs={12}>
        <Grid className={classes.gridBtn} item xs>
          <div>
            <Button
              className={css({ borderRadius: 20 })}
              color="primary"
              disabled
              fullWidth
              variant="contained"
            >
              Envoyer un message
            </Button>
          </div>
        </Grid>
      </Grid> */}
    </div>
  );
};

const styles = ({ spacing }) => ({
  containerInfo: {
    padding: spacing(2, 0),
  },
  avatar: {
    height: 90,
    width: 90,
  },
  nameContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',

    marginLeft: spacing(1),
  },
  name: {
    display: 'flex',
    alignItems: 'center',
  },
  LabelContainer: {
    paddingLeft: spacing(2),
  },
  gridBtn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  favBtn: {
    textAlign: 'right',
  },
  ButtonContainer: {
    padding: spacing(2),
  },
  address: {
    display: 'flex',
    alignItems: 'center',
    marginTop: spacing(0.5),
  },
});

ProfilName.propTypes = {
  userId: PropTypes.string,
};

export default ProfilName;
